export const traverse = (obj: any, fun: ((key: string, value: any, path: string) => void)) => {
  const step = (obj: any, crumbs: string[] = []) => {
    for (const [key, value] of Object.entries(obj))  {
      const path = [...crumbs, key].join('.');
      fun(key, value, path);
      if (value !== null && (typeof value === 'object' || Array.isArray(value))) {
        step(value, [...crumbs, key]);
      }
    }
  }
  step(obj);
}
